export default "__VITE_ASSET__ByV7FUkw__"